"use client";

import { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Grid,
  Paper,
  Autocomplete,
} from "@mui/material";
import {
  Phone,
  Person,
  Category,
  LocationCity,
  LocationOn,
  CallEnd,
  Comment,
  Send,
} from "@mui/icons-material";
import axios from "axios";

const AddLeadsForAgent = () => {
  const [formData, setFormData] = useState({
    phoneNumber: "",
    sellerName: "",
    productCategory: "",
    alternateNumber: "",
    city: "",
    state: "",
    callStatus: "",
    callRemark: "",
  });
  const [leadsDashboardData, setLeadDashboardData] = useState();
  const [loading, setLoading] = useState(true);
  const [dropdownOptions, setDropdownOptions] = useState({
    productCategories: [],
    cities: [],
    states: [],
    callStatuses: [],
  });

  const submitData = () => {
    setLoading(true);
    axios
      .post(process.env.REACT_APP_PATH + "/sales/saveCallReport", formData)
      .then((res) => {
        if (res.data.success) {
          alert(res.data?.message || "Successfully update");
          getAllCallReport();
          setFormData({
            phoneNumber: "",
            sellerName: "",
            productCategory: "",
            alternateNumber: "",
            city: "",
            state: "",
            callStatus: "",
            callRemark: "",
          });
        } else {
          alert(res.data?.message || "Something went wrong");
          setLoading(false);
        }
      })
      .catch((error) => {
        alert("someting went wrong");
        setLoading(false);
      });
  };

  const getAllCallReport = async () => {
    setLoading(true);
    axios
      .get(process.env.REACT_APP_PATH + "/sales/getAgentCallReportDashboard")
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          setLeadDashboardData(res.data.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        let getCityAndState = await axios.post(
          process.env.REACT_APP_PATH +
            "/sales/callDropdowns?filterType=cityAndState"
        );
        let productCategories = await axios.post(
          process.env.REACT_APP_PATH +
            "/sales/callDropdowns?filterType=productCategories"
        );
        let callStatus = await axios.post(
          process.env.REACT_APP_PATH +
            "/sales/callDropdowns?filterType=callStatus"
        );
        if (getCityAndState.data && productCategories.data && callStatus.data) {
          setDropdownOptions({
            productCategories: productCategories.data.data,
            cities: getCityAndState.data.data,
            callStatuses: callStatus.data.data,
          });
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchDropdownData();
    getAllCallReport();
  }, []);

  // Handle form input changes
  const handleInputChange = (field, value) => {
    if (field == "alternateNumber" || field == "phoneNumber") {
      if (value.length <= 10) {
        setFormData((prev) => ({
          ...prev,
          [field]: value,
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }

    // Auto-select state based on city selection
    if (field === "city") {
      const selectedCity = dropdownOptions.cities.find(
        (city) => city.city === value
      );
      if (selectedCity) {
        setFormData((prev) => ({
          ...prev,
          state: selectedCity.state,
        }));
      }
    }
  };

  return (
    <div style={{position:'relative'}}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{ backgroundColor: "#fff" }}
      >
        <Typography variant="h4">Add Lead For Agent</Typography>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h4">Welcome, {localStorage.getItem('name')||''}</Typography>
        </Box>
      </Box>

      <Box sx={{ p: 3, backgroundColor: "#B6E1E4", minHeight: "100vh" }}>
        {/* Summary Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Lead Summary (Today) */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%", border: "2px solid #000" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 2,
                    textDecoration: "underline",
                  }}
                >
                  Lead Summary (Today)
                </Typography>
                <Box sx={{ textAlign: "left" }}>
                  {leadsDashboardData?.todaySummary && (
                    <>
                      {leadsDashboardData?.todaySummary?.totalLeads ? (
                        <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                          Total Leads :{" "}
                          {leadsDashboardData?.todaySummary?.totalLeads || 0}
                        </Typography>
                      ) : null}
                      {Object.entries(
                        leadsDashboardData?.todaySummary?.callStatusCounts
                      ).map((item) => {
                        return (
                          <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                            {item[0]} : {item[1]}
                          </Typography>
                        );
                      })}
                    </>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Hourly Leads (Today) */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%", border: "2px solid #000" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 2,
                    textDecoration: "underline",
                  }}
                >
                  Hourly Leads (Today)
                </Typography>
                <Box sx={{ textAlign: "left" }}>
                  {leadsDashboardData?.hourlyLeadsToday.map((item) => {
                    return (
                      <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                        {item?.hour} : {item?.count}
                      </Typography>
                    );
                  })}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Lead Summary (Till Date) */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%", border: "2px solid #000" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 2,
                    textDecoration: "underline",
                  }}
                >
                  Lead Summary (Till Date)
                </Typography>
                <Box sx={{ textAlign: "left" }}>
                  {leadsDashboardData?.tillDateSummary && (
                    <>
                      <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                        Total Leads :{" "}
                        {leadsDashboardData?.tillDateSummary?.totalLeads || 0}
                      </Typography>
                      {Object.entries(
                        leadsDashboardData?.tillDateSummary?.callStatusCounts
                      ).map((item) => {
                        return (
                          <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                            {item[0]} : {item[1]}
                          </Typography>
                        );
                      })}
                    </>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Form Fields */}
        <Grid container spacing={3}>
          {/* Contact No - Manual Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                placeholder="Contact No"
                value={formData.phoneNumber}
                onChange={(e) =>
                  handleInputChange("phoneNumber", e.target.value)
                }
                variant="outlined"
                type="number"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "white",
                  },
                  "& input[type=number]::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                }}
                InputProps={{
                  startAdornment: <Phone sx={{ mr: 1, color: "#666" }} />,
                  style: {
                    MozAppearance: "textfield",
                  },
                }}
                inputProps={{
                  inputMode: "numeric",
                  maxLength: 10,
                }}
              />
            </Box>
          </Grid>

          {/* Seller Name - Manual Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                // label="Seller Name"
                placeholder="Seller Name"
                value={formData.sellerName}
                onChange={(e) =>
                  handleInputChange("sellerName", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "white",
                  },
                }}
                InputProps={{
                  startAdornment: <Person sx={{ mr: 1, color: "#666" }} />,
                }}
              />
            </Box>
          </Grid>

          {/* Product Category - Dropdown */}
          <Grid item xs={12} md={4}>
            <Box>
              <FormControl fullWidth>
                <InputLabel
                  id="dropdown-label"
                  style={{ backgroundColor: "white", color: "#000" }}
                >
                  Select Product Category
                </InputLabel>
                <Select
                  value={formData.productCategory}
                  onChange={(e) =>
                    handleInputChange("productCategory", e.target.value)
                  }
                  placeholder="Product Category"
                  sx={{
                    border: "2px solid #000",
                    backgroundColor: "white",
                  }}
                  startAdornment={<Category sx={{ mr: 1, color: "#666" }} />}
                >
                  {dropdownOptions.productCategories.map((category) => (
                    <MenuItem key={category} value={category}>
                      {category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* Alternate No - Manual Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                placeholder="Alternate No"
                value={formData.alternateNumber}
                type="text"
                onChange={(e) =>
                  handleInputChange("alternateNumber", e.target.value)
                }
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "white",
                  },
                  "& input[type=number]::-webkit-outer-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                  "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                  },
                }}
                inputProps={{
                  inputMode: "numeric",
                  maxLength: 10,
                }}
                InputProps={{
                  startAdornment: <Phone sx={{ mr: 1, color: "#666" }} />,
                  style: {
                    MozAppearance: "textfield",
                  },
                }}
              />
            </Box>
          </Grid>

          {/* City Name - Dropdown */}
          <Grid item xs={12} md={4}>
            <Box>
              <FormControl fullWidth>
                <Autocomplete
                  value={formData.city}
                  onChange={(event, newValue) =>
                    handleInputChange("city", newValue)
                  }
                  options={dropdownOptions.cities.map((city) => city.city)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select City"
                      placeholder="City Name"
                      style={{ borderRadius: 12 }}
                      sx={{
                        // backgroundColor: "white",
                        border: "2px solid #000",
                        // borderRadius:
                      }}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <LocationCity sx={{ mr: 1, color: "#666" }} />
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Box>
          </Grid>

          {/* State Name - Auto Pick Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                placeholder="State Name"
                value={formData.state}
                variant="outlined"
                disabled
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "#f0f0f0",
                  },
                }}
                InputProps={{
                  startAdornment: <LocationOn sx={{ mr: 1, color: "#666" }} />,
                }}
              />
            </Box>
          </Grid>

          {/* Call Status - Dropdown */}
          <Grid item xs={12} md={4}>
            <Box>
              <FormControl fullWidth>
                <InputLabel
                  id="dropdown-label"
                  style={{ backgroundColor: "white", color: "#000" }}
                >
                  Call Status
                </InputLabel>
                <Select
                  value={formData.callStatus}
                  labelId="dropdown-label"
                  onChange={(e) =>
                    handleInputChange("callStatus", e.target.value)
                  }
                  placeholder="Call Status"
                  sx={{
                    border: "2px solid #000",
                    backgroundColor: "white",
                  }}
                  startAdornment={<CallEnd sx={{ mr: 1, color: "#666" }} />}
                >
                  {dropdownOptions.callStatuses.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* Call Remarks - Manual Field */}
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                fullWidth
                placeholder="Call Remarks"
                value={formData.callRemark}
                onChange={(e) =>
                  handleInputChange("callRemark", e.target.value)
                }
                variant="outlined"
                multiline
                rows={3}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    border: "2px solid #000",
                    backgroundColor: "white",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <Comment
                      sx={{
                        mr: 1,
                        color: "#666",
                        alignSelf: "flex-start",
                        mt: 1,
                      }}
                    />
                  ),
                }}
              />
            </Box>
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Button
                variant="contained"
                onClick={submitData}
                sx={{
                  backgroundColor: "#000",
                  color: "white",
                  borderRadius: "25px",
                  px: 4,
                  py: 2,
                  fontSize: "16px",
                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#333",
                  },
                }}
                startIcon={<Send />}
                disabled={
                  !formData.city ||
                  !formData.productCategory ||
                  !formData.callStatus ||
                  !formData.sellerName ||
                  !formData.callRemark ||
                  !formData.phoneNumber ||
                  loading ||
                  formData.phoneNumber.length != 10
                }
              >
                Submit
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default AddLeadsForAgent;
